var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myDivInput",attrs:{"contenteditable":"","placeholder":_vm.placeholder,"oninput":"if(this.innerHTML.trim()==='<br>')this.innerHTML=''"}})
}
var staticRenderFns = []

export { render, staticRenderFns }